/* tslint:disable */
/* eslint-disable */
export enum ProgramAuditSetting {
  ProgramAuditRead = 'programAudit_read',
  ProgramAuditWrite = 'programAudit_write',
  ProgramAuditAssignSelf = 'programAudit_assignSelf',
  ProgramAuditAssignOther = 'programAudit_assignOther',
  ProgramAuditBulkStatusUpdate = 'programAudit_bulkStatusUpdate',
  ProgramAuditReopen = 'programAudit_reopen',
}
